<template>
  <div
    class="clue-card-loading"
    :style="{ fontSize: fontSize + 'px', marginBottom: marginBottom + 'px' }"
  >
    {{ text }}
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: ''
  },
  fontSize: {
    type: [String, Number],
    default: 12
  },
  marginBottom: {
    type: [String, Number],
    default: 8
  }
})
</script>

<style scoped>
.clue-card-loading {
  /* 1. 设置字号 */
  background-image: linear-gradient(90deg, #969799 0%, #e3e3e5 50%, #969799 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: grayFlow 3s linear infinite;
}

@keyframes grayFlow {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: -200% center;
  }
}
</style>
